var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212 32h600c32.8 0 60 27.2 60 60v840c0 32.8-27.2 60-60 60h-600c-32.8 0-60-27.2-60-60v-840C152 59.2 179.2 32 212 32z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4 876H271.2c-10.4 0-19.2-8.8-19.2-19.2V713.6c0-10.4 8.8-19.2 19.2-19.2h143.2c10.4 0 19.2 8.8 19.2 19.2v143.2c0 10.4-8.8 19.2-19.2 19.2z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 1000h-600c-37.6 0-68-30.4-68-68v-840C144 54.4 174.4 24 212 24h600c37.6 0 68 30.4 68 68v840c0 37.6-30.4 68-68 68zM212 40C183.2 40 160 63.2 160 92v840c0 28.8 23.2 52 52 52h600c28.8 0 52-23.2 52-52v-840c0-28.8-23.2-52-52-52h-600z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4 330.4H271.2c-10.4 0-19.2-8.8-19.2-19.2v-144c0-10.4 8.8-19.2 19.2-19.2h143.2c10.4 0 19.2 8.8 19.2 19.2v143.2c0 11.2-8.8 20-19.2 20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4 338.4H271.2c-15.2 0-27.2-12-27.2-27.2v-144c0-15.2 12-27.2 27.2-27.2h143.2c15.2 0 27.2 12 27.2 27.2v143.2c0 15.2-12 28-27.2 28zM271.2 156c-6.4 0-11.2 4.8-11.2 11.2v143.2c0 6.4 4.8 11.2 11.2 11.2h143.2c6.4 0 11.2-4.8 11.2-11.2V167.2c0-6.4-4.8-11.2-11.2-11.2H271.2z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4 603.2H271.2c-10.4 0-19.2-8.8-19.2-19.2V440c0-10.4 8.8-19.2 19.2-19.2h143.2c10.4 0 19.2 8.8 19.2 19.2v144c0 10.4-8.8 19.2-19.2 19.2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4 611.2H271.2c-15.2 0-27.2-12-27.2-27.2V440c0-15.2 12-27.2 27.2-27.2h143.2c15.2 0 27.2 12 27.2 27.2v144c0 14.4-12 27.2-27.2 27.2zM271.2 428.8c-6.4 0-11.2 4.8-11.2 11.2v144c0 6.4 4.8 11.2 11.2 11.2h143.2c6.4 0 11.2-4.8 11.2-11.2V440c0-6.4-4.8-11.2-11.2-11.2H271.2zM414.4 884H271.2c-15.2 0-27.2-12-27.2-27.2V713.6c0-15.2 12-27.2 27.2-27.2h143.2c15.2 0 27.2 12 27.2 27.2v143.2c0 15.2-12 27.2-27.2 27.2zM271.2 701.6c-6.4 0-11.2 4.8-11.2 11.2V856c0 6.4 4.8 11.2 11.2 11.2h143.2c6.4 0 11.2-4.8 11.2-11.2V713.6c0-6.4-4.8-11.2-11.2-11.2H271.2zM414.4 338.4H271.2c-15.2 0-27.2-12-27.2-27.2v-144c0-15.2 12-27.2 27.2-27.2h143.2c15.2 0 27.2 12 27.2 27.2v143.2c0 15.2-12 28-27.2 28zM271.2 156c-6.4 0-11.2 4.8-11.2 11.2v143.2c0 6.4 4.8 11.2 11.2 11.2h143.2c6.4 0 11.2-4.8 11.2-11.2V167.2c0-6.4-4.8-11.2-11.2-11.2H271.2z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4 611.2H271.2c-15.2 0-27.2-12-27.2-27.2V440c0-15.2 12-27.2 27.2-27.2h143.2c15.2 0 27.2 12 27.2 27.2v144c0 14.4-12 27.2-27.2 27.2zM271.2 428.8c-6.4 0-11.2 4.8-11.2 11.2v144c0 6.4 4.8 11.2 11.2 11.2h143.2c6.4 0 11.2-4.8 11.2-11.2V440c0-6.4-4.8-11.2-11.2-11.2H271.2zM414.4 884H271.2c-15.2 0-27.2-12-27.2-27.2V713.6c0-15.2 12-27.2 27.2-27.2h143.2c15.2 0 27.2 12 27.2 27.2v143.2c0 15.2-12 27.2-27.2 27.2zM271.2 701.6c-6.4 0-11.2 4.8-11.2 11.2V856c0 6.4 4.8 11.2 11.2 11.2h143.2c6.4 0 11.2-4.8 11.2-11.2V713.6c0-6.4-4.8-11.2-11.2-11.2H271.2zM768 247.2H548c-4.8 0-8-3.2-8-8s3.2-8 8-8H768c4.8 0 8 3.2 8 8s-3.2 8-8 8z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 520H548c-4.8 0-8-3.2-8-8s3.2-8 8-8H768c4.8 0 8 3.2 8 8s-3.2 8-8 8z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.4 792.8H546.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h220c4.8 0 8 3.2 8 8s-4 8-8 8z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9fbd11ea46a260d090d5f443ae6be2c5.svg";
export { ForwardRef as ReactComponent };